import { useLocation } from "react-router-dom";

import { StateApiErrorType } from "commons/hooks/useNavigateToApiErrorPage";

import DisplayApiError from "components/DisplayApiError";

function ErrorApi() {
    const location = useLocation();

    const state = location.state as StateApiErrorType;

    return <DisplayApiError state={state} />;
}

export default ErrorApi;
